import React from "react"
import { Box, Grid, Heading, Container, Flex, Text } from "@theme-ui/components"

const PageIntro = ({ block }) => {
  const { kicker, title, subtitle } = block

  return (
    <Box sx={{ backgroundColor: "primary", mt: 0 }}>
      <Container>
        <Text
          variant="kicker"
          sx={{
            border: "1px solid",
            color: "light",
            display: "block",
            color: "light",
            mt: [5, 5, 8],
          }}
        >
          {kicker}
        </Text>
        <Flex sx={{ flexDirection: "column", mt: [5, 5, 7], mb: [4, 5, 6, 8] }}>
          <Box>
            <Heading
              as="h1"
              sx={{
                color: "light",
                fontWeight: 500,
                fontSize: ["34px", "48px"],
              }}
            >
              {title}
            </Heading>
          </Box>
          <Box
            sx={{
              fontSize: ["34px", "48px"],

              a: {
                color: "light",
                textDecoration: "none",
                ":hover": {
                  textDecoration: "underline",
                },
              },
              color: "light",

              lineHeight: ["1.15", "1.15"],
              color: "light",
              p: { fontWeight: 500 },
            }}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        </Flex>
      </Container>
    </Box>
  )
}

export default PageIntro
